
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M29.96 12c5.84 0 6.55.02 8.84.13 5.94.27 8.71 3.08 8.99 8.98.11 2.31.13 3 .13 8.85s-.02 6.54-.13 8.85c-.28 5.88-3.05 8.71-8.99 8.98-2.29.11-2.98.13-8.84.13-5.86 0-6.55-.02-8.86-.13-5.94-.27-8.69-3.1-8.97-8.98-.11-2.31-.13-3-.13-8.85s.02-6.54.13-8.85c.28-5.89 3.05-8.71 8.97-8.98 2.31-.1 3-.13 8.86-.13v0z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M29.96 38.91a8.96 8.96 0 100-17.92 8.96 8.96 0 000 17.92z","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M41 21a2.1 2.1 0 100-4.2 2.1 2.1 0 000 4.2z","fill":"currentColor"}})])
          )
        }
      }
    